export default __webpack_public_path__ + "static/TriDymeIconV1-cf2813e0841ac9f3eeb3b44ed8c0f76f.png";